import { Tooltip } from 'antd';

export const AppTooltip = ({ label, children, placement = 'top', delay = 0.28 }) => {
  if (!label) return children;

  return (
    <Tooltip
      title={label}
      placement={placement}
      mouseEnterDelay={delay}
      mouseLeaveDelay={0.08}
      overlayClassName='app-tooltip'
      arrow={{ pointAtCenter: true }}
    >
      {children}
    </Tooltip>
  );
};
